import { render, staticRenderFns } from "./CostsChecker.vue?vue&type=template&id=4fb58066&scoped=true&"
import script from "./CostsChecker.vue?vue&type=script&lang=js&"
export * from "./CostsChecker.vue?vue&type=script&lang=js&"
import style0 from "./CostsChecker.vue?vue&type=style&index=0&id=4fb58066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb58066",
  null
  
)

export default component.exports